function cloneArr(obj) {
  return [...obj];
}

function cloneObj(obj) {
  return { ...obj };
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export default { cloneArr, cloneObj };
